import React from "react";
import style from "../../../assets/scss/common/modal/refundModal.module.scss";
import {Trans, useTranslation} from "react-i18next";
import {useLanguage} from "../../../hooks/hooks";

interface RefundInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const RefundModal: React.FC<RefundInfoModalProps> = ({ isOpen, onClose }) => {
  const { isKorean} = useLanguage();
  const {t} = useTranslation("modal");
  if (!isOpen) {
    return null;
  }

  const handleRefundInquiry = () => {
    if (isKorean) {
      window.open("https://pf.kakao.com/_xjxlpDG/chat", "_blank");
    }
    onClose();
  };

  return (
      <div className={style.refundModalOverlay}>
        <div className={style.refundModal}>
          <div className={style.refundModalContent}>
            <h2 className={style.titleText}>
              <span className={style.boldText}>{t("refund.title")}</span>
            </h2>
          </div>
          <div className={style.refundTextContainer}>
            <Trans t={t} i18nKey={"refund.desc"} components={{br: <br />}} />
          </div>
          <div className={style.buttonContainer}>
            <button onClick={onClose} className={style.cancelButton}>
              {t("cancel")}
            </button>
            <button onClick={handleRefundInquiry} className={style.refundCloseButton}>
              {t("refund.request")}
            </button>
          </div>
        </div>
      </div>
  );
};

export default RefundModal;
